/**
 * ListingCard
 * 
 * @Author: Focci
 * @Date: 2023-08-02 20:41:08
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-02 20:41:08
 */

import PropTypes from 'prop-types'
import PremiumAgent from '@comp/page/common/card/agent/premium/PremiumAgent'
import ListingPromoteAd from '@page/common/card/ListingPromoteAd'
import ListingPromoteAgent from '@page/common/card/ListingPromoteAgent'
import PropertyCard from '@page/common/card/property'
import { filter, flatten, isArray, map } from 'lodash-es'
import { houseSearchType } from '@lib/config'
import { getListingData } from '../get-listing-data'

/**
 * 估价列表，检查是否为 premium
 */
export function checkSoldPremium(house, type) {
  return (
    type === houseSearchType.sold
    && filter(
      isArray(house.simple_agents) ? house.simple_agents : [], 
      (f) => f.membership_level === 3
    ).length > 0
  )
}

export function getItemId(house) {
  let r
  if(house.is_ad) {
    r = house?.ad?.id
  }

  if(house.is_premium_agent) {
    const pIds = map(isArray(house.properties) ? house.properties : [], 'id')
    const sIds = map(isArray(house.sold_properties) ? house.sold_properties : [], 'id')

    r = flatten([pIds, sIds, Math.random()]).join(',')
  }
  if(house.is_agent) {
    r = house?.agent?.id
  }
  try {
    r = house?.id || JSON.stringify(house)
  } catch(err) { /**/ }

  return r
}

export default function ListingCard({
  house = {},
  agentAvatarProps,
  variant,
  type,
  slideChangeTrackingPageType,
  favoriteTrackingPageType
}) {
  // 广告
  if(house.is_ad && house.ad) {
    return (
      <ListingPromoteAd 
        data={house.ad}
      />
    )
  }
  // premium agent
  if(house.is_premium_agent || checkSoldPremium(house, type)) {
    return (
      <PremiumAgent 
        house={house}
        variant={variant}
        type={type}
      />
    )
  }
  // 推广中介
  if(house.is_agent) {
    return (
      <ListingPromoteAgent
        data={house.agent} 
      />
    )
  }
  // 房源卡片
  return (
    <PropertyCard
      house={getListingData(house, type)}
      variant={variant}
      type={type}
      agentAvatarProps={agentAvatarProps}
      slideChangeTrackingPageType={slideChangeTrackingPageType}
      favoriteTrackingPageType={favoriteTrackingPageType}
    />
  )
}

ListingCard.propTypes = {
  house: PropTypes.object,
  variant: PropTypes.string,
  type: PropTypes.string,
}
